module.exports = "/static/assets/9684b10804a422e28712aa058933bd7a.png";